
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acerca-de-spotme/[topic]",
      function () {
        return require("private-next-pages/acerca-de-spotme/[topic]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acerca-de-spotme/[topic]"])
      });
    }
  